import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  TextField,
  IconButton,
  Button,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  makeStyles,
  CircularProgress,
  Typography,
} from "@material-ui/core";

import StyledButton from "../../../../common/models/Button";
import { Cancel, Save } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";

const useStyles = makeStyles((theme) => ({
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "950px",
  },
  footerContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
  },
  resetChangesButton: {
    border: "1px solid #000000",
    color: "#000000",
    fontWeight: 600,
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    marginTop: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  backButton: {
    backgroundColor: "#555",
    color: "#fff",
    borderRadius: 20,
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  saveButton: {
    backgroundColor: "#f26522",
    color: "#fff",
    borderRadius: 20,
    padding: "8px 24px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "4px",
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: 20,
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  deleteIcon: {
    color: "red", // Set the color to red
    "&:hover": {
      color: "#d32f2f", // Darker red on hover
    },
  },
  editIcon: {
    color: "#f26522", // Set the color to orange
    "&:hover": {
      color: "#d4551a", // Darker orange on hover
    },
  },
  modalityBoxWrapper: {
    display: "flex",
    alignItems: "flex-start",
  },
  containerBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: "4px 8px",
    backgroundColor: "#fff",
    maxWidth: 250,
  },
  textField: {
    flexGrow: 1,
    "& .MuiInputBase-input": {
      padding: "6px 8px",
    },
  },

  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },
  iconBtn: {
    padding: 6,
  },
  iconBtn: {
    padding: 6,
    color: "#000",
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  productCellWrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
}));

const ManufacturingFacilityTypeTab = (props) => {
  const { featuresAccess, sponsorId } = props;
  const classes = useStyles();
  const [facilityTypes, setFacilityTypes] = useState([]); // Facility types list
  const [newRow, setNewRow] = useState({
    id: null,
    name: "",
    products: [],
   
    selected: false,
    isNew: true,
  }); // New row state
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [productOptions, setProductOptions] = useState([]);
  const [isUpdated, setIsUpdated] = useState(false); // Initialize as false
  const [errorMessage, setErrorMessage] = useState("");
  const [savingStates, setSavingStates] = useState({});
  const [editingIndex, setEditingIndex] = useState(null);
  const [editAssociatedProductTypes, setEditAssociatedProductTypes] = useState([]);
  
  // Get edit access from featuresAccess
  const canEdit = featuresAccess?.editSponsorNetworkDetails ?? false;

  const fetchFacilityTypes = async () => {
    try {
      setLoading(true); // Show loading indicator
      setError(null); // Clear any previous errors

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchFacilityTypes/false`;
      const response = await axios.get(url);

      const data = response?.data?.data;

      //console.log("API Facility Types Data:", data);

      if (data?.status === true || data?.status === "true") {
        const list = data.facilityTypesList || [];

        const formatted = list.map((item, index) => ({
          id: item.facilityTypeID || `ID-${index + 1}`,
          name: item.facilityTypeName || "",
          type: item.facilityType || "default",
          selected: !!item.activated,
          associatedProductTypes: (item.associatedProductTypes || []).map(
            (product) => ({
              id: product.productTypeID,
              name: product.productTypeName,
            })
          ),
          lastUpdatedBy: item.lastUpdatedBy || "",
          isNew: false,
        }));

        setFacilityTypes(formatted); 
          setError("");// Update the state with the fetched facility types
      } 
    } catch (error) {
      console.error("Error fetching facility types:", error);
       setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false); // Hide loading indicator
    }
  };

  useEffect(() => {
    fetchFacilityTypes();
    fetchProductOptions();
  }, []);

  const fetchProductOptions = async () => {
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchProductTypes/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;

      //console.log("API Product Options Data:", data);

      if (data?.status === true || data?.status === "true") {
        const options = data.productTypeList.map((item) => ({
          id: item.productTypeID,
          name: item.productTypeName,
        }));
        setProductOptions(options); // Update the product options state
      } else {
        console.error("Failed to fetch product options.");
      }
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const handleSaveNewFacilityType = async (index) => {
    const facilityType = facilityTypes[index];
    if (!facilityType.name?.trim() || savingStates[index]) return;
    setSavingStates((prev) => ({ ...prev, [index]: true }));
    try {
      // Prepare the payload for the API
      const payload = {
        sponsorId: sponsorId,
        ecosystemId: localStorage.getItem("ecosystemId"),
        facilityTypesList: [
          {
            facilityTypeName: facilityType.name, // Facility type name
            facilityType: "New", // Facility type (default if not provided)
            activated: facilityType.selected, // Activation status
            associatedProductTypesList: facilityType?.products?.map(
              (product) => ({
                productTypeName: product?.name, // Product type name
                productTypeID: product?.id, // Product type ID
              })
            ),
          },
        ],
      };

      //console.log("Payload for saving facility type:", payload); // Debugging

      // Call the API to save the facility type
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addFacilityTypes`;
      const response = await axios.post(url, payload);

      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("Facility type saved successfully:", response.data);
        props.setManufacturingFacilityType((prev) => !prev);
        // Update the state to mark the row as saved
        setFacilityTypes((prev) =>
          prev?.map((row, i) =>
            i === index
              ? { ...row, id: response.data?.data?.id, isNew: false }
              : row
          )
        );

        await fetchFacilityTypes(); // Refresh the facility types list
      } else {
        console.error("Failed to save facility type:", response.data?.message);
      }
    } catch (error) {
      console.error("Error saving facility type:", error);
    }
    setSavingStates((prev) => ({ ...prev, [index]: false }));
  };

  const handleDelete = async (index) => {
    const facilityType = facilityTypes[index];
    if (facilityType.isNew) {
      setFacilityTypes((prev) => prev.filter((_, i) => i !== index)); // Remove the row from the state
      //console.log("Unsaved facility type deleted internally:", facilityType);
      return;
    } // Get the facility type at the specified index
    // if (isUpdated) {
      try {
        // Prepare the payload for the API
        const payload = {
          sponsorId: sponsorId,
          ecosystemId: localStorage.getItem("ecosystemId"), // Example ecosystemId
          facilityTypesList: [
            {
              facilityTypeName: facilityType.name, // Facility type name
              facilityTypeID: facilityType.id, // Facility type ID
              activated: facilityType.selected, // Activation status
              associatedProductTypesList:
                facilityType?.associatedProductTypes?.map((product) => ({
                  productTypeName: product?.name, // Product type name
                  productTypeID: product?.id, // Product type ID
                })),
              markForDelete: true, // Mark this facility type for deletion
            },
          ],
        };

        //console.log("Payload for deleting facility type:", payload); // Debugging

        // Call the API to delete the facility type
        const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFacilityTypes`;
        const response = await axios.post(url, payload);

        if (
          response.data?.status === true ||
          response.data?.status === "true"
        ) {
          //console.log("Facility type deleted successfully:", response.data);
          await fetchFacilityTypes();
          props.setManufacturingFacilityType((prev) => !prev);
          // Remove the facility type from the state
          setFacilityTypes((prev) => prev.filter((_, i) => i !== index));
        } else {
          console.error(
            "Failed to delete facility type:",
            response.data?.message
          );
        }
      } catch (error) {
        console.error("Error deleting facility type:", error);
      }
    // } else {
    //   // If not updated, just remove from state
    //   setFacilityTypes((prev) => prev.filter((_, i) => i !== index));
    // }
  };

  const handleSaveChanges = async (updatedFacilityTypes) => {
   //console.log("handleSaveChanges CALLED");
    try {
      // Check if at least one toggle is turned on
      const isAnyToggleOn = facilityTypes.filter(
        (facility) => facility.isUpdated
      );
      if (!isAnyToggleOn.length) {
        //console.log("No updates detected. Proceeding to the next step.");

        return;
      }

      // if (!isAnyToggleOn.length) {
      //   setErrorMessage(
      //     "Please activate at least one Manufacturing Facility Type."
      //   ); // Show error message
      //   return; // Exit the function
      // }
      if (facilityTypes.every((facility) => !facility.selected)) {
        setErrorMessage("Please enable at least one in toggle mode.");
        return;
      }

      // Prepare the payload for the API - include all facility types
      const payload = {
        sponsorId: sponsorId, // Example sponsorId
        ecosystemId: localStorage.getItem("ecosystemId"), // Example ecosystemId
        facilityTypesList: isAnyToggleOn.map((facility) => ({
          facilityTypeName: facility.name,
          facilityTypeID: facility.id,
          activated: facility.selected,
          associatedProductTypesList: facility?.associatedProductTypes?.map(
            (product) => ({
              productTypeName: product?.name || "Unknown",
              productTypeID: product?.id || null,
            })
          ),
        })),
      };

      //console.log(payload, "Payload for API"); // Debugging

      // Call the API to update the facility types
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFacilityTypes`;
      const response = await axios.post(url, payload);
      await fetchFacilityTypes();
      if (response.data?.status === true || response.data?.status === "true") {
        //console.log("Facility types updated successfully:", response.data);

        // Move to the next tab
      } else {
        console.error(
          "Failed to update facility types:",
          response.data?.message
        );
        setErrorMessage(
          response.data?.message || "Failed to update facility types."
        );
      }
    } catch (error) {
      console.error("Error updating facility types:", error);
      setErrorMessage("An error occurred while updating the facility types.");
    }
  };
  // const handleNextClick = async () => {
  //   try {
  //     // Check if at least one toggle is turned on
  //     const isAnyToggleOn = facilityTypes.filter(
  //       (facility) => facility.isUpdated
  //     );
  //     if (!isAnyToggleOn.length) {
  //       console.log("No updates detected. Proceeding to the next step.");
  //       props.handleNext(); // Directly move to the next tab
  //       return;
  //     }

  //     // if (!isAnyToggleOn.length) {
  //     //   setErrorMessage(
  //     //     "Please activate at least one Manufacturing Facility Type."
  //     //   ); // Show error message
  //     //   return; // Exit the function
  //     // }
  //     if (facilityTypes.every((facility) => !facility.selected)) {
  //       setErrorMessage("Please enable at least one in toggle mode.");
  //       return;
  //     }

  //     // Prepare the payload for the API - include all facility types
  //     const payload = {
  //       sponsorId: 2, // Example sponsorId
  //       ecosystemId: 1, // Example ecosystemId
  //       facilityTypesList: isAnyToggleOn.map((facility) => ({
  //         facilityTypeName: facility.name,
  //         facilityTypeID: facility.id,
  //         activated: facility.selected,
  //         associatedProductTypesList: facility?.associatedProductTypes?.map(
  //           (product) => ({
  //             productTypeName: product?.name || "Unknown",
  //             productTypeID: product?.id || null,
  //           })
  //         ),
  //       })),
  //     };

  //     console.log(payload, "Payload for API"); // Debugging

  //     // Call the API to update the facility types
  //     const url = `${appUrl}/Pharma%20Contract%20Manufacturing/N1/sh1/Pharma%20Co/Admin/updateFacilityTypes`;
  //     const response = await axios.post(url, payload);
  //     await fetchFacilityTypes();
  //     if (response.data?.status === true || response.data?.status === "true") {
  //       console.log("Facility types updated successfully:", response.data);

  //       // Move to the next tab
  //       props.handleNext();
  //     } else {
  //       console.error(
  //         "Failed to update facility types:",
  //         response.data?.message
  //       );
  //       setErrorMessage(
  //         response.data?.message || "Failed to update facility types."
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error updating facility types:", error);
  //     setErrorMessage("An error occurred while updating the facility types.");
  //   }
  // };

const handleEditSaveChanges = async (updatedFacilityTypes) => {
 // console.log("handleSaveChanges CALLED");
  try {
    // Use the passed-in array if available, otherwise fallback to state
    const types = updatedFacilityTypes || facilityTypes;
    const isAnyToggleOn = types.filter(
      (facility) => facility.isUpdated
    );
    if (!isAnyToggleOn.length) {
      //console.log("No updates detected. Proceeding to the next step.");
      return;
    }
    if (types.every((facility) => !facility.selected)) {
      setErrorMessage("Please enable at least one in toggle mode.");
      return;
    }
    const payload = {
      sponsorId: sponsorId,
      ecosystemId: localStorage.getItem("ecosystemId"),
      facilityTypesList: isAnyToggleOn.map((facility) => ({
        facilityTypeName: facility.name,
        facilityTypeID: facility.id,
        activated: facility.selected,
        associatedProductTypesList: facility?.associatedProductTypes?.map(
          (product) => ({
            productTypeName: product?.name || "Unknown",
            productTypeID: product?.id || null,
          })
        ),
      })),
    };
    //console.log(payload, "Payload for API"); // Debugging

    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFacilityTypes`;
    const response = await axios.post(url, payload);
    await fetchFacilityTypes();
    if (response.data?.status === true || response.data?.status === "true") {
      //console.log("Facility types updated successfully:", response.data);
    } else {
      setErrorMessage(
        response.data?.message || "Failed to update facility types."
      );
    }
  } catch (error) {
    setErrorMessage("An error occurred while updating the facility types.");
  }
};

  const handleToggle = (index) => {
    setFacilityTypes((prev) =>
      prev.map((facility, i) =>
        i === index
          ? { ...facility, selected: !facility.selected, isUpdated: true }
          : facility
      )
    );
    setIsUpdated(true); // Mark as updated
  };

  const handleCancel = (index) => {
    setFacilityTypes((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddNew = () => {
    // const nextId = (facilityTypes.length + 1).toString().padStart(2, "0"); // Generate a unique ID
    setFacilityTypes([
      ...facilityTypes,
      {
        // id: nextId, // Use the generated ID
        name: "",
        products: [],
        associatedProductTypes: [],
        selected: false,
        isNew: true,
      },
    ]);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    setFacilityTypes((prev) =>
      prev.map((facility, i) =>
        i === index ? { ...facility, name: value } : facility
      )
    );
    setIsUpdated(true); // Mark as updated
  };
  const handleResetChanges = async () => {
    //console.log("Resetting changes...");
    await fetchFacilityTypes(); // Call the fetch API to reset the facility types
    setIsUpdated(false); // Mark as not updated
    //console.log("Changes reset successfully."); 
  };
  const toggleEditMode = (index) => {
    setFacilityTypes((prev) =>
      prev.map((facility, i) =>
        i === index ? { ...facility, isEditing: !facility.isEditing } : facility
      )
    );
  };

  // Render component
  return (
    <div style={{ padding: 16 }}>
      <div
        className={classes.container}
        style={{ display: "flex", flexDirection: "column", gap: "24px" }}
      >
        {/* Table and Buttons Section */}
        <div style={{ display: "flex", gap: "40px", alignItems: "flex-start" }}>
          <TableContainer component={Paper} className={`${classes.table} default-table-styles`}>
            <Table>
              <TableHead  >
                <TableRow>
                  <TableCell >
                    <b>Selection</b>
                  </TableCell>
                  <TableCell>
                    <b>Manufacturing Facility Type</b>
                  </TableCell>
                  <TableCell style={{whiteSpace: 'nowrap'}}>
                    <b>Manufacturing Facility Type ID</b>
                  </TableCell>
                  <TableCell>
                    <b>Associated Product Types</b>
                  </TableCell>
                  <TableCell>
                    <b>Action</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100px",
                        }}
                      >
                        <CircularProgress />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : error ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "60px",
                          backgroundColor: "#ffecec",
                          color: "#b00020",
                          border: "1px solid #ff9999",
                        }}
                      >
                        <Typography>{error}</Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  facilityTypes.map((item, index) => (
                    <TableRow key={item.id || `new-${index}`}>
                      <TableCell>
                        <Switch
                          checked={item.selected}
                          onChange={() => handleToggle(index)}
                          disabled={!canEdit}
                        />
                      </TableCell>
                      <TableCell>
                        {item.isNew ? (
                          <TextField
                            value={item.name}
                            onChange={(e) =>
                              handleNameChange(index, e.target.value)
                            }
                            onBlur={(e) => {
                              const { value } = e.target;
                              // Trim leading and trailing spaces for string values
                              if (typeof value === "string" && value.trim() !== value) {
                                handleNameChange(index, value.trim());
                              }
                            }}
                            placeholder="Enter Facility Type Name"
                            size="small"
                            variant="outlined"
                            inputProps={{
                              onBeforeInput: (e) => {
                                const allowedChars = /^[a-zA-Z0-9\s\-.,&/()]+$/;
                                if (!allowedChars.test(e.data)) {
                                  e.preventDefault();
                                }
                              }
                            }}
                          />
                        ) : (
                          item.name
                        )}
                      </TableCell>
                      <TableCell>{item.id}</TableCell>
                      {/* <TableCell>
                        {item.isNew ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Select
                              multiple
                              displayEmpty
                              value={
                                item.products
                                  ? item.products.map((product) => product.id)
                                  : []
                              } // Use IDs for the value
                              onChange={(e) => {
                                const selectedIds = e.target.value; // Array of selected IDs
                                const selectedProducts = productOptions.filter(
                                  (option) => selectedIds.includes(option.id)
                                ); // Get the selected products (id and name)

                                setFacilityTypes((prev) =>
                                  prev.map((row, i) =>
                                    i === index
                                      ? { ...row, products: selectedProducts }
                                      : row
                                  )
                                );
                                setIsUpdated(true);
                              }}
                              onOpen={fetchProductOptions} // Fetch product options when the dropdown is opened
                              renderValue={(selected) =>
                                selected.length > 0
                                  ? selected
                                      .map(
                                        (id) =>
                                          productOptions.find(
                                            (option) => option.id === id
                                          )?.name
                                      )
                                      .join(", ")
                                  : "Select from the list"
                              }
                              style={{ width: 200 }}
                              size="small"
                              variant="outlined"
                            >
                              {productOptions.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                  <Checkbox
                                    checked={
                                      item.products
                                        ? item.products.some(
                                            (product) =>
                                              product.id === option.id
                                          )
                                        : false
                                    }
                                  />
                                  <ListItemText primary={option.name} />
                                </MenuItem>
                              ))}
                            </Select>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <IconButton
                                onClick={() => handleCancel(index)}
                                className={classes.iconBtn}
                              >
                                <CancelIcon fontSize="small" />
                              </IconButton>
                              <IconButton
                                onClick={() => handleSaveNewFacilityType(index)}
                                className={classes.iconBtn}
                              >
                                <SaveIcon fontSize="small" />
                              </IconButton>
                            </div>
                          </div>
                        ) : (
                          // Array.isArray(item.associatedProductTypes) &&
                          // item.associatedProductTypes.map((product) => (
                          //   <Typography key={product.id}>{product.name}</Typography>
                          // ))
                          Array.isArray(item.associatedProductTypes) && (
                            <Typography component="span">
                              {item.associatedProductTypes.map(
                                (product, index) => (
                                  <Typography key={product.id} component="span">
                                    {product.name}
                                    {index <
                                      item.associatedProductTypes.length - 1 &&
                                      ", "}
                                  </Typography>
                                )
                              )}
                            </Typography>
                          )
                        )}
                      </TableCell> */}
                  <TableCell>
  {item.isNew ? (
    // For new rows, show the dropdown multi-select directly (no pencil icon)
    <div style={{ display: "flex", alignItems: "center" }}>
      <Select
        multiple
        displayEmpty
        value={
          item.products
            ? item.products.map((product) => product.id)
            : []
        }
        onChange={(e) => {
          const selectedIds = e.target.value;
          const selectedProducts = productOptions.filter(
            (option) => selectedIds.includes(option.id)
          );
          setFacilityTypes((prev) =>
            prev.map((row, i) =>
              i === index ? { ...row, products: selectedProducts } : row
            )
          );
          setIsUpdated(true);
        }}
       // onOpen={fetchProductOptions}
        renderValue={(selected) =>
          selected.length > 0
            ? selected
                .map(
                  (id) =>
                    productOptions.find((option) => option.id === id)?.name
                )
                .join(", ")
            : "Select from the list"
        }
        style={{ width: 200 }}
        size="small"
        variant="outlined"
      >
        {productOptions.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox
              checked={
                item.products
                  ? item.products.some((product) => product.id === option.id)
                  : false
              }
            />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <IconButton
          onClick={() => handleCancel(index)}
          className={classes.iconBtn}
        >
          <CancelIcon fontSize="small" />
        </IconButton>
        <IconButton
          onClick={() => handleSaveNewFacilityType(index)}
          className={classes.iconBtn}
          disabled={
            !facilityTypes[index].name?.trim() ||
            facilityTypes.some(
              (f, i) =>
                i !== index &&
                f.name?.trim().toLowerCase() === facilityTypes[index].name?.trim().toLowerCase()
            ) || savingStates[index]
          }     
        >
          <SaveIcon fontSize="small" />
        </IconButton>
      </div>
    </div>
  ) : item.isEditing ? (
    // Existing edit logic for editing rows (keep as is)
    <div style={{ display: "flex", alignItems: "center" }}>
      <Select
       multiple
  displayEmpty
  value={editAssociatedProductTypes.map((product) => product.id)}
  onChange={(e) => {
    const selectedIds = e.target.value;
    const selectedProducts = productOptions.filter(
      (option) => selectedIds.includes(option.id)
    );
    setEditAssociatedProductTypes(selectedProducts);
    setIsUpdated(true);
  }}
        renderValue={(selected) =>
          selected.length > 0
            ? selected
                .map(
                  (id) =>
                    productOptions.find((option) => option.id === id)?.name
                )
                .join(", ")
            : "Select from the list"
        }
        style={{ width: 200 }}
        size="small"
        variant="outlined"
      >
        {productOptions.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            <Checkbox
              // checked={
              //   item.associatedProductTypes
              //     ? item.associatedProductTypes.some(
              //         (product) => product.id === option.id
              //       )
              //     : false
              // }
               checked={editAssociatedProductTypes.some(product => product.id === option.id)}
            />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginLeft: 8,
        }}
      >
          <IconButton
          onClick={() => toggleEditMode(index)}
          className={classes.iconBtn}
        >
          <CancelIcon fontSize="small" />
        </IconButton>
<IconButton
  onClick={async () => {
    const updated = facilityTypes.map((row, i) =>
      i === index
        ? { ...row, associatedProductTypes: editAssociatedProductTypes, isUpdated: true, isEditing: false }
        : row
    );
    setFacilityTypes(updated);
    setIsUpdated(true);
    setEditingIndex(null);
    // Wait for state to update, then call API
    setTimeout(() => {
      // Use the updated array directly to ensure API sees the latest changes
      handleEditSaveChanges(updated);
    }, 0);
  }}
  className={classes.iconBtn}
>
  <SaveIcon fontSize="small" />
</IconButton>

      </div>
    </div>
  ) : (
    // Existing display logic for non-editing rows (keep as is)
    <div style={{ display: "flex", alignItems: "center" }}>
      <Typography component="span">
        {item.associatedProductTypes.map((product, i) => (
          <Typography key={product.id} component="span">
            {product.name}
            {i < item.associatedProductTypes.length - 1 && ", "}
          </Typography>
        ))}
      </Typography>
      {item.type === "New" && item.lastUpdatedBy !== "support@schrocken.com" && (
      <IconButton
  onClick={() => {
    setEditingIndex(index);
    setEditAssociatedProductTypes(item.associatedProductTypes || []);
    toggleEditMode(index);
  }}
  className={classes.iconBtn}
>
  <EditIcon fontSize="small" style={{ color: 'orange' }} />
</IconButton>
)}
    </div>
  )}
</TableCell>

                      <TableCell>
                       {canEdit && (item.isNew === true || (item.type === "New" && item.lastUpdatedBy !== "support@schrocken.com")) && (
                          <IconButton
                            onClick={() => handleDelete(index)} // Handle delete for both new and existing rows
                            className={classes.deleteIcon}
                          >
                            <DeleteIcon />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <div
            className={classes.footer}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "16px", // Space between buttons
              marginTop: "16px", // Space between table and buttons
              marginLeft: "16px", // Space between table and buttons
            }}
          >
            <Button
              className={classes.saveButton}
              type="button"
              onClick={handleSaveChanges}
              disabled={!isUpdated || !canEdit}
              style={{
    
    opacity: !isUpdated || !canEdit ? 0.7 : 1, // Fade out when disabled
    color: "#fff", 
  }}
            >
              Save Selection
            </Button>
            <Button
              className={classes.resetChangesButton}
              type="button"
              onClick={handleResetChanges}
               disabled={!isUpdated || !canEdit} // or whatever your "no changes" condition is
  style={{
    opacity: !isUpdated || !canEdit ? 0.8 : 1, // Fade out when disabled
  }}
            >
              Reset Selection
            </Button>
          </div>
        </div>
      </div>
      {errorMessage && (
        <div style={{ color: "red", marginTop: 10 }} className="error-message">
          {errorMessage}
        </div>
      )}
      {canEdit && (
        <Button
          variant="outlined"
          className={classes.addButton}
          onClick={handleAddNew}
        >
          <span className={classes.addIconCircle}>+</span>
          Add New Manufacturing Facility Type
        </Button>
      )}

      {/* <div className={classes.footerContainer}>
        <Button
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          ⬅ Back
        </Button>
        <div className={classes.footer}>
          <StyledButton
            className={classes.saveButton}
            onClick={() => {
              if (isUpdated) {
                handleNextClick(); // Call API and move to the next tab if updates are made
              } else {
                props.handleNext(); // Directly move to the next tab if no updates are made
              }
            }}
          >
            Save & Next
          </StyledButton>
        </div>
      </div> */}
    </div>
  );
};

export default ManufacturingFacilityTypeTab;
